export const validFileInclusion = function (str) {
  const regEx = /:\/\/|\.\.\//;
  return regEx.test(str);
}
